// extracted by mini-css-extract-plugin
export var subheading = "dynamic-zone-component-module--subheading--RqWdH";
export var sectionImage = "dynamic-zone-component-module--sectionImage--FQOki";
export var sectionImageCopyright = "dynamic-zone-component-module--sectionImageCopyright--yTutc";
export var sectionEmbeded = "dynamic-zone-component-module--sectionEmbeded--mXmm-";